import { render, staticRenderFns } from "./systemMicrofront.vue?vue&type=template&id=134981cf"
import script from "./systemMicrofront.vue?vue&type=script&lang=js"
export * from "./systemMicrofront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports